module.exports = __webpack_public_path__ + "img/nor_kc_moun2.1f2fe085.png";